
export default function textPlainHeader () {
  return { accept: '*/*', 'Content-Type': 'text/plain' }
}
